import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { MMEApi } from '../../../apis/MMEApi/MMEApi.ts';
import { ISavedMMECalculation } from '../MME.ts';

export function useDeleteSavedMMECalculation(patientID: number | undefined) {
    const queryClient = useQueryClient();

    return useMutation<void, AppMedError, number>({
        mutationKey: [QueryKeys.mmeSavedCalculations],
        mutationFn: async (calculationID: number) => {
            return await MMEApi.deleteCalculation(calculationID);
        },
        onSuccess: (_, calculationID) => {
            // Update the cache by removing the deleted calculation
            queryClient.setQueryData<ISavedMMECalculation[]>(
                [QueryKeys.mmeSavedCalculations, patientID],
                (prev) => prev?.filter((calc) => calc.id !== calculationID) ?? [],
            );

            // Invalidate the query to ensure fresh data
            queryClient.invalidateQueries({ queryKey: [QueryKeys.mmeSavedCalculations, patientID] });
        },
        onError: (error) => {
            console.error('Error deleting MME calculation:', error);
        },
    });
}
